export enum OffersTab {
  'private-offers' = 1,
  'channel-offers' = 2,
}

export const keyToEnumValueMap = new Map<string, OffersTab>([
  ['private-offers', OffersTab['private-offers']],
  ['channel-offers', OffersTab['channel-offers']],
])
